import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { searchConstants } from '../../../search-utils/searchConstants';
import { SortTypes } from '../../../search.types';
import styles from './sort_dropdown.module.scss';

type Props = {
  handleClick: Function;
  isSelected: boolean;
  type: SortTypes;
};

export const SortButton: FC<Props> = ({ isSelected, handleClick, type }) => (
  <button type="button" className={styles.listItem} onClick={handleClick(type)}>
    {isSelected && (
      <i
        className={classNames(
          'material-icons icons__check',
          styles.listItemIcon,
        )}
      />
    )}

    <span className={styles.listItemLabel}>
      <FormattedMessage id={searchConstants.sorts[type].labelId} />
    </span>
  </button>
);
